import { render, staticRenderFns } from "./Cat.vue?vue&type=template&id=2ff32089&scoped=true&"
import script from "./Cat.vue?vue&type=script&lang=js&"
export * from "./Cat.vue?vue&type=script&lang=js&"
import style0 from "./Cat.vue?vue&type=style&index=0&id=2ff32089&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff32089",
  null
  
)

export default component.exports